"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _LazyKeyStore = require("crm_data/store/LazyKeyStore");

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _AssociatedOpenObjectsAPI = require("crm_ui/engagementAssociations/apis/AssociatedOpenObjectsAPI");

var _makeBatch = _interopRequireDefault(require("crm_data/api/makeBatch"));

var batchFetch = (0, _makeBatch.default)(function (id) {
  var objectType = id.get('objectType');
  var subjectId = id.get('subjectId');
  var objectTypeToFetch = id.get('objectTypeToFetch');
  return (0, _AssociatedOpenObjectsAPI.fetch)(objectType, subjectId, objectTypeToFetch);
}, 'AssociatedOpenObjectsStore.fetch');
(0, _LazyKeyStore.registerLazyKeyService)({
  namespace: _ActionNamespaces.ASSOCIATED_OPEN_OBJECTS,
  fetch: batchFetch
});

var _default = (0, _LazyKeyStore.defineLazyKeyStore)({
  namespace: _ActionNamespaces.ASSOCIATED_OPEN_OBJECTS,
  idIsValid: function idIsValid(key) {
    return _immutable.Map.isMap(key) && typeof key.get('subjectId') === 'string' && typeof key.get('objectType') === 'string' && typeof key.get('objectTypeToFetch') === 'string';
  }
}).register();

exports.default = _default;
module.exports = exports.default;